import React from "react";
import { RatingType } from "./feedback.types";

interface Props {
  selected: RatingType | null;
  onSelect: (rating: RatingType) => void;
}

const RatingSelector: React.FC<Props> = ({ selected, onSelect }) => {
  return (
    <div className="rating-container">
      <button
        className={`rating-btn ${selected === "bad" ? "active" : ""}`}
        onClick={() => onSelect("bad")}
      >
        😔 Bad
      </button>

      <button
        className={`rating-btn ${selected === "decent" ? "active" : ""}`}
        onClick={() => onSelect("decent")}
      >
        😊 Decent
      </button>

      <button
        className={`rating-btn ${selected === "love" ? "active" : ""}`}
        onClick={() => onSelect("love")}
      >
        😍 Love it
      </button>
    </div>
  );
};

export default RatingSelector;